import { normalize } from 'normalizr'
import { arrayOfRates } from '../rateSchema'

export default importedRates => ({ ...normalize(importedRates, arrayOfRates) })



// WEBPACK FOOTER //
// ./src/adapters/parsers/importedRates.js